<kt-base-modal [title]="'Task'">
  <div modal-body>
    <div>
      <div class="fix-body-height">
        <ngb-accordion #acc="ngbAccordion" id="ngb-panel-0">
          <ng-container *ngFor="let task of (tasks?.task_groups || []);let index = index">
            <ngb-panel id="ngb-panel-{{index}}">
              <ng-template ngbPanelHeader let-opened="opened">
                <div class="d-flex align-items-center justify-content-between py-2 px-3">
                  <h6 class="m-0">
                    <span class="w-100">
                      <span>{{task.task_group_name}}</span>
                    </span>

                  </h6>
                  <a class="btn btn-sm btn-clean btn-icon btn-icon-sm ms-3" [class.action-in-flight]="loading()"
                    (click)="taskGroupEditClickHandler($event, task)" href="javascript:;">
                    <svg-icon *ngIf="!viewMode" class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/add.svg"></svg-icon>
                    <svg-icon *ngIf="viewMode" class="svg_icon13x13 d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/view.svg"></svg-icon>
                  </a>
                </div>
              </ng-template>
              <ng-template ngbPanelTitle>
              </ng-template>
              <ng-template ngbPanelContent>
                <ng-container *ngFor="let item of task.actual_task_group">
                  <div class="task-list-item border-bottom">
                    <div class="description me-3 w-100">
                      <span><b>Task Name: </b> {{item.timesheet_log_name}}</span>
                      <span><b>Filled At: </b>{{item.timesheet_log_created_at | TimezoneDateTime}}</span>
                    </div>
                    <div>
                      <button type="button" class="btn btn-sm btn-clean btn-icon btn-icon-sm" [disabled]="loading()"
                        (click)="taskGroupEditClickHandler($event, task, item )">
                        <svg-icon class="d-inline" src="assets/media/iq-svg/without_circle/icon_set_3/view.svg"></svg-icon>
                      </button>
                    </div>
                  </div>
                </ng-container>
              </ng-template>
            </ngb-panel>
          </ng-container>
        </ngb-accordion>
        <ng-container *ngIf="!viewMode">
          <div class="text-end mt-3">
            <button class="btn btn-brand btn-sm" [style.cursor]="currentStatus === shiftStatusEnum.OnBreak || currentStatus === shiftStatusEnum.None ? 'default' : 'pointer'" (click)="addClickHandler()" [disabled]="currentStatus === shiftStatusEnum.OnBreak || currentStatus === shiftStatusEnum.None"> Add New Task Group</button>
          </div>
          <div class="m-1 p-3 h5 text-center " *ngIf="tasks?.custom_actual_task_group?.length">
            Custom Task
          </div>
          <div class="kt-notification">
            <ng-container *ngFor="let customTask of tasks.custom_actual_task_group">
              <a href="javascript:;" class="kt-notification__item" [class.action-in-flight]="loading()"
                (click)="taskGroupEditClickHandler($event, null, customTask )">
                <div class="kt-notification__item-details">
                  <div class="kt-notification__item-title">
                    {{customTask.timesheet_task_group_fk_task_group_name}}
                  </div>
                </div>
              </a>

            </ng-container>


          </div>
        </ng-container>




      </div>
      <div class="d-flex modal-footer justify-content-start">
        <kt-button [buttonConfig]="buttonConfig.CLOSE_BUTTON_CONFIG" (buttonClick)="activeModal.close()">
        </kt-button>
        <!--
        <kt-button [buttonConfig]="buttonConfig.SAVE_BUTTON_CONFIG" (buttonClick)="startBreakHandler()">
        </kt-button> -->
      </div>
    </div>
  </div>
</kt-base-modal>
